import React from 'react';
import styled from 'styled-components';
import { Text, Card } from '@teals/ui-web';
import { Link } from 'react-router-dom';

const Page = styled.div`
  max-width: 960px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
`;

/** Staff Console stub — cross-org analytics belongs here later. */
const Staff: React.FC = () => (
  <Page>
    <Text variant="h2">Staff Console</Text>
    <Card style={{ marginTop: '1.5rem', padding: '1.5rem' }}>
      <Text variant="body1">
        Cross-organisation analytics and internal cost views will live here.
        Customer tenant Analytics stays tokens-only on{' '}
        <Link to="/analytics">/analytics</Link>.
      </Text>
    </Card>
  </Page>
);

export default Staff;
